var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCanvasHeight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 6.594,
    viewBox: "0 0 15 6.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrows-alt-h",
    "data-name": "Icon awesome-arrows-alt-h",
    d: "M11.072,10.978v1.379H3.927V10.978a.7.7,0,0,0-1.2-.508L.206,13.047a.73.73,0,0,0,0,1.016L2.727,16.64a.7.7,0,0,0,1.2-.508V14.752h7.145v1.379a.7.7,0,0,0,1.2.508l2.521-2.577a.73.73,0,0,0,0-1.016L12.273,10.47A.7.7,0,0,0,11.072,10.978Z",
    transform: "translate(0 -10.258)",
    fill: "#2c2c2c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasHeight);
export default __webpack_public_path__ + "static/media/canvas-height.ea1f6407164ecf168d789fdd8e32186f.svg";
export { ForwardRef as ReactComponent };